import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ArticleCarousel = () => {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    fetch("https://justurbane.in/backend_php/public/api/carousel")
      .then((res) => res.json())
      .then((data) => setSlides(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides]);

  const handleRedirect = (link) => {
    if (!link) return;
    // const formattedCategory = category.toLowerCase().replace(/\s+/g, '-');
    window.location.href = link;
  };

  const nextSlide = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  if (slides.length === 0) return null;

  return (
    <div className="w-full flex justify-center py-6 bg-gray-50">
      {/* Changed to fixed height for a smaller, professional look like the reference */}
      <div className="relative w-full max-w-6xl h-[500px] overflow-hidden shadow-xl rounded-lg cursor-pointer group bg-black">
        <AnimatePresence mode='wait'>
          <motion.div
            key={current}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="absolute inset-0 w-full h-full"
            onClick={() => handleRedirect(slides[current].link)}
          >
            {/* Removed blurry background. Image is now sharp and fills the container. */}
            <img
              src={slides[current].image_url}
              alt={slides[current].title}
              className="absolute inset-0 w-full h-full object-cover z-10 transition-transform duration-1000 group-hover:scale-105"
            />

            {/* Stronger, solid dark overlay for professionalism and readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent z-20" />

            <div className="absolute inset-x-0 bottom-0 p-8 md:p-12 flex flex-col justify-end z-30">
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.6 }}
              >
                <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-widest text-white uppercase bg-red-600 rounded-sm">
                  {slides[current].category}
                </span>

                <h1 className="text-3xl md:text-4xl lg:text-5xl font-sans font-bold text-white leading-tight mb-4">
                  {slides[current].title}
                </h1>

                <p className="text-gray-300 text-base md:text-lg line-clamp-2 mb-6 max-w-3xl">
                  {slides[current].description}
                </p>

                <div className="flex items-center text-white font-semibold group-hover:text-red-400 transition-colors">
                  <span>Read Full Story</span>
                  <svg className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Navigation controls remain clean and professional */}
        <div className="absolute bottom-8 right-8 z-40 flex items-center space-x-4">
          <div className="flex space-x-2">
            <button 
              onClick={prevSlide}
              className="p-2 rounded-full bg-black/50 border border-white/20 text-white hover:bg-red-600 hover:border-red-600 transition-all"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button 
              onClick={nextSlide}
              className="p-2 rounded-full bg-black/50 border border-white/20 text-white hover:bg-red-600 hover:border-red-600 transition-all"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCarousel;